import { type FontAttribs } from '@cx-web/domain-types';

/**
 * Best-effort font preconnects. These are non-blocking hints — the page renders
 * acceptably with the `sans-serif` fallbacks in ErrorPageStyles if they never resolve.
 */
const baseFonts: FontAttribs[] = [
  // Public Sans, Open Sans, Lato
  {
    rel: 'preconnect',
    href: 'https://fonts.googleapis.com',
  },
  {
    rel: 'preconnect',
    href: 'https://fonts.gstatic.com',
    crossOrigin: 'anonymous',
  },
  // Futura PT Condensed
  {
    rel: 'preconnect',
    href: 'https://use.typekit.net',
  },
];

export const Fonts = () => {
  return (
    <>
      {baseFonts.map(data => (
        <link key={`${data.rel}-${data.href}`} {...data} />
      ))}
    </>
  );
};
